import { style } from "@vanilla-extract/css";
import { breakpoints } from "plos/src/styles";

export const toggleButtonWrapper = style({
  "@media": {
    [`screen and (min-width: ${breakpoints[2]})`]: {
      maxWidth: "60%",
    },
  },
});
